import React from 'react';
import RepeatSelect from 'components/RepeatSelect';
import shopSelectors from 'services/selectors/shop';
import styled from 'styled-components';
import qbSignal from './signal';
import { ANYONE_ID } from 'Calendar/anyone';

/**
 * Chon chu ky lap cho lich sap dat.
 *
 * An hoan toan khi tiem chua bat cau hinh repeat. Server cung chan endpoint theo dung cau
 * hinh do, nen day chi la lop UX phia truoc chu khong phai chot chan duy nhat.
 */
/**
 * Repeat chi ap dung cho mot staff cu the: server tu choi lap lich chua chon tho vi khong co
 * gi de kiem tra trung lich. Luat nay quyet dinh ca viec hien section lan viec giu gia tri lap.
 */
export const canRepeatForStaff = (staffId?: string) => !!staffId && staffId !== ANYONE_ID;

const RepeatSection = ({ staffId }: { staffId?: string }) => {
  const enableAppointmentRepeat = shopSelectors.setting().enableAppointmentRepeat;
  const groupAssignEnabled = shopSelectors.setting().quickBookingGroupAssign;
  // Doc het signal truoc moi nhanh return: so signal doc duoc phai giong nhau qua cac lan
  // render, neu khong so hook cua component se lech va React tuot slot sang hook ke tiep.
  const totalPeople = qbSignal.totalPeople.value;
  const dayRepeat = qbSignal.repeatDayRepeat.value;

  if (!enableAppointmentRepeat) return null;

  // An luon o day, neu khong nhan vien dat xong moi biet repeat that bai.
  if (!canRepeatForStaff(staffId)) return null;

  // Dat nhom di qua buoc gan tho va tao nhieu lich cung luc, khong co mot lich goc de nhan
  // ban thanh chuoi. Gia tri lap duoc don o noi bam so khach, nen an la du.
  if (groupAssignEnabled && totalPeople >= 2) return null;

  return (
    <RepeatSectionStyled className='section-wrapper'>
      <div className="section-label">REPEAT</div>
      <RepeatSelect
        value={dayRepeat}
        onChange={(value) => {
          qbSignal.repeatDayRepeat.value = value;
        }}
      />
    </RepeatSectionStyled>
  );
};

export default RepeatSection;

const RepeatSectionStyled = styled.div`
  margin-top: 8px;
`;
